import MovesRemainingLabel from './MovesRemainingLabel'

export default MovesRemainingLabel
